var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlugged(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#212121;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M586.2,244.3c46.8,61.6,42.1,149.8-14.1,206l-55.6,55.6c-8.4,8.4-21.9,8.4-30.3,0L294.3,313.9 c-8.4-8.4-8.4-21.9,0-30.3l55.6-55.6c56.2-56.2,144.5-60.9,206.1-14.1l87-87c8.4-8.4,21.9-8.4,30.3,0s8.4,21.9,0,30.3L586.2,244.3z  M501.4,460.4l40.4-40.4c44.6-44.6,44.6-117,0-161.6c-44.6-44.6-117-44.6-161.6,0l-40.4,40.4L501.4,460.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.6,337.2l84.2,84.2l30.3,30.3l23.6,23.6c8.4,8.4,8.4,21.9,0,30.3l-55.6,55.6 c-56.2,56.2-144.5,60.9-206.1,14.1l-87,87c-8.4,8.4-21.9,8.4-30.3,0c-8.4-8.4-8.4-21.9,0-30.3l87-87 C178,483.4,182.8,395.1,239,338.9l55.6-55.6c8.4-8.4,21.9-8.4,30.3,0l23.5,23.5L378.6,337.2z M269.5,531 c44.6,44.4,116.9,44.4,161.4-0.2l40.4-40.4L309.7,328.8l-40.4,40.4c-44.6,44.6-44.6,116.8-0.2,161.4l0.2,0.2L269.5,531z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugged);
export default __webpack_public_path__ + "static/media/plugged.eb4904a4d6260e2874ea1ea7fc61245f.svg";
export { ForwardRef as ReactComponent };